import React from "react"
import { connect } from "react-redux"
import classnames from "classnames"
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap"

import AuthHeader from "components/Headers/AuthHeader.js"
import { resetPassword } from "actions/loginAction"

class ForgotPassword extends React.Component {
  state = {
    email: "",
  }

  onChange = (stateName, value) => {
    this.setState({
      [stateName]: value,
    })
  }

  render() {
    const { authError } = this.props
    const { authSuccess } = this.props

    return (
      <>
        <AuthHeader />
        <Container className="mt--8 pb-5">
          <Row className="justify-content-center">
            <Col lg="5" md="7">
              <Card className="bg-secondary border-0 mb-0">
                <CardBody className="px-lg-5 py-lg-5">
                  <div className="text-center text-muted mb-4">
                    <h3>Reset Password</h3>
                    <small>
                      Please enter your email below to reset your password
                    </small>
                  </div>
                  <Form role="form">
                    <FormGroup
                      className={classnames("mb-3", {
                        focused: this.state.focusedEmail,
                      })}
                    >
                      <InputGroup className="input-group-merge input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="ni ni-email-83" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Email"
                          type="email"
                          onFocus={() => this.setState({ focusedEmail: true })}
                          onBlur={() => this.setState({ focusedEmail: false })}
                          onChange={(e) =>
                            this.onChange("email", e.target.value)
                          }
                        />
                      </InputGroup>
                    </FormGroup>
                    <div className="text-center">
                      <Button
                        className="my-4"
                        color="default"
                        type="button"
                        onClick={() => {
                          const { email } = this.state
                          if (email) {
                            this.props.resetPassword(email)
                          }
                        }}
                      >
                        Reset
                      </Button>
                      <span className="text-danger">
                        {authError ? <p>{authError}</p> : null}
                      </span>
                      <span className="text-success">
                        {authSuccess ? <p>{authSuccess}</p> : null}
                      </span>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    authError: state.authState.authError,
    authSuccess: state.authState.authSuccess,
  }
}

const mapDispatchToProps = (dispatch) => ({
  resetPassword: (email) => dispatch(resetPassword(email)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)
